import { useQuery } from '@tanstack/react-query'
import { apiCall } from '@/api/client'
import type { SiteInfo } from '@/types'

async function fetchSites(): Promise<SiteInfo[]> {
  const resp = await apiCall('GET', '/api/sites')
  if (!resp.ok) {
    throw new Error(`Failed to fetch sites: ${resp.status}`)
  }
  const data = await resp.json()
  return data.sites
}

export function useSites() {
  return useQuery({
    queryKey: ['sites'],
    queryFn: fetchSites,
  })
}
